<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
// import { defineAsyncComponent, ref } from "vue";
// import moment from "moment";



export default {
    page: {
        title: "Detail Nilai Evaluasi Pelaksanaan",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {

        return {
            title: "Detail Evaluasi Penyelenggaraan",
            items: [
                {
                    text: "Pelaksanaan",
                    href: "/",
                },
                {
                    text: "Data Pelaksanaan",
                    href: "/pra-pelaksanaan/pembelajaran",
                },
                {
                    text: "Detail Data Pelaksanaan",
                    active: true,
                },
            ],

            id: this.$route.params.id,
            nomor_surat: null,
            kode: null,
            judul: null,
            dasar_pelaksanaan: null,
            strategi: null,
            strategi_id: null,
            durasi_he: null,
            durasi_jp: null,
            tanggal_mulai: null,
            tanggal_selesai: null,
            learning_type: null,
            angkatan: null,

            // Data Table Penyelenggaraan
            loadingTable: true,
            table_data: [],
            
           
        };
    },
    mounted() {
        let self = this;
        Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,
        });

        // get data pembelajaran
        var config = {
            method: "get",
            url:
                process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
            params: {
                id: self.id,
            },
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.access_token,
            },
        };
        axios(config)
            .then(function (response) {
                var response_data = response.data;
                var response_data_fix = response_data.data;
                if (response_data.meta.code == 200) {
                    var data_edit = response_data_fix.data_pembelajaran;
                    self.nomor_surat = data_edit.pbl_nomor_surat;
                    self.kode = data_edit.pbl_kode;
                    self.judul = data_edit.pbl_dasar_pelaksanaan;
                    self.dasar_pelaksanaan = data_edit.pbl_judul;
                    self.strategi = data_edit.pbl_strategi;
                    self.strategi_id = data_edit.pbl_strategi_id;
                    self.durasi_he = data_edit.pbl_durasi_he;
                    self.durasi_jp = data_edit.pbl_durasi_jp;
                    self.tanggal_mulai = data_edit.pbl_tgl_mulai;
                    self.tanggal_selesai = data_edit.pbl_tgl_selesai;
                    self.learning_type = data_edit.pbl_lt_name;
                    self.angkatan = data_edit.pbl_angkatan;

                    self.pratikum = data_edit.pbl_pratikum;

                    self.getData();
                } else {
                    Swal.close();
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response_data_fix.data.message,
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
                Swal.close();
            });
    },
    methods: {
        getData() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });

            // get data pembelajaran
            var config = {
                method: "get",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penyelenggaraan",
                params: {
                    id: self.id,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };
            axios(config)
                .then(function (response) {
                    console.log("Hasil Penyelenggaraan ----");
                    console.log(response);
                    self.loadingTable = false;
                    self.table_data = response.data.data[0];

                    Swal.close();
                })
                .catch(function (error) {
                    console.log(error);
                    Swal.close();
                });
        },
        storeNilai(){
            let self= this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });

            const datafix = self.table_data
            .map(rowData => ({
                id: rowData.mep_id,
                mep_nilai_angka: rowData.mep_nilai_angka,
                mep_catatan: rowData.mep_catatan
            }))
            

            var config ={
                method: "put",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penyelenggaraan/edit",
                data:{
                   datafix
                },
                headers:{
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                }
            };
            axios(config).
            then((response)=>
            {
            if(response.data.meta.code == 200){
                Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil di simpan.",
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
                })
            self.getData();
            }else{
                Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: 'Something went wrong !',
                showConfirmButton: true,
                });
            }
            })
        }
    },
};
</script>
<style></style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-12 text-end mb-3">
                        <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detail/` + id" class="btn btn-danger"><i class="fa fa-arrow-left"></i> <b>Kembali</b></router-link>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                    <template v-slot:header>
                                        <h5 class="my-0 text-primary">
                                            <i class="mdi mdi-calendar-edit me-3"></i> Formulir
                                            Perencanaan Pembelajaran
                                        </h5>
                                    </template>
                                    <div class="card-body p-0">
                                        <div class="row">
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Nomor Surat</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ nomor_surat }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Kode Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ kode }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Dasar Pelaksanaan</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">
                                                            {{ dasar_pelaksanaan }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Judul Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ judul }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Strategi</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ strategi }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Tipe Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ learning_type }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">PIC</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ pic }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Angkatan</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ angkatan }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Pratikum</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ pratikum }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Durasi Hari Efektif (HE)</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ durasi_he }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Durasi Jam Pembelajaran (JP)</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ durasi_jp }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Tanggal Mulai</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">
                                                                {{ tanggal_mulai }}
                                                            </p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 font-size-12">
                                                                <span class="text-dark">Tanggal Selesai</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">
                                                                {{ tanggal_selesai }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>
                            </div>
                            <div class="col-12">
                                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                    <h4 class="card-title mb-3">Data Evaluasi Penyelenggaraan</h4>


                                    <div class="row mb-3">
                                        <div class="col-12 text-end">
                                            <b-button variant="info" size="sm">
                                            <i class="fas fa-upload"></i>
                                            &nbsp;
                                            <b>Import Nilai </b>
                                            </b-button>
                                            &nbsp;
                                            <b-button variant="info" size="sm" >
                                            <i class="fas fa-file-excel"></i>
                                            &nbsp;
                                            <b>Export Nilai </b>
                                            </b-button>
                                        </div>
                                    </div>

                                    <form method="put">
                                    <div class="card-body p-0">

                                            <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
                                                <thead class="align-middle greyTheme">
                                                    <tr>
                                                        <th>
                                                            NO
                                                        </th>
                                                        <th>
                                                            ASPEK
                                                        </th>
                                                        <th>
                                                            NILAI
                                                        </th>
                                                        <th>
                                                            CATATAN
                                                        </th>
                                                    </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="loadingTable">
                                                    <td colspan="99">
                                                        <i class="fas fa-spinner fa-spin"></i> Loading...
                                                    </td>
                                                </tr>
                                                <tr v-else-if="table_data == ''">
                                                    <td colspan="99" class="text-center">Data Kosong</td>
                                                </tr>
                                                <tr v-else v-for="(rowData, keyData) in table_data" :key="keyData">
                                                    <td class="text-center" v-if="Number.isInteger(rowData.mep_urutan)">
                                                        {{ rowData.mep_urutan }}
                                                    </td>
                                                    <td class="text-center" v-else>&nbsp;</td>
                                                    <td v-if="Number.isInteger(rowData.mep_urutan)">
                                                        <b>{{ rowData.mep_aspek }}</b>
                                                    </td>
                                                    <td v-else>
                                                        {{ rowData.mep_urutan }}. {{ rowData.mep_aspek_child }}
                                                    </td>
                                                    <template  v-if="rowData.mep_nilai_angka != null">
                                                        <td>
                                                            <input type="text" class="form-control bg-light border-dark" v-model= "rowData.mep_nilai_angka" />
                                                        </td>
                                                        <td>
                                                            <input type="text" class="form-control bg-light border-dark" v-model= "rowData.mep_catatan" />
                                                        </td>
                                                    </template>
                                                    <template v-else>
                                                        <td colspan="2">&nbsp;</td>
                                                    </template>
                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    <div class="row mt-3">
                                        <div class="col-12 text-end">
                                            <b-button variant="success" size="m" @click="storeNilai()">
                                                <i class="fas fa-upload"></i>
                                                &nbsp;
                                                <b>Save Nilai </b>
                                            </b-button>
                                        </div>
                                    </div>
                                </form>
                                    
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>
